.options-container {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1100;
  top: 0px;
}

.filters-container {
  background-color: var(--color-background);
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1100;
  .filters-treks-container,
  .filters-touristic-contents-container,
  .filters-touristic-events-container,
  .filters-outdoor-sites-container {
    height: 100%;
  }
  .segmented-buttons-container {
    display: flex;
    justify-content: center;
    width: calc(100% - 32px);
    height: 40px;
    margin: 16px;
    border: 1px solid var(--color-outline);
    border-radius: var(--border-radius, 20px);
    line-height: 20px;
    .segment {
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      font-weight: 500;
      -webkit-tap-highlight-color: transparent;
      color: var(--color-on-surface-variant);
      background-color: transparent;
      border-radius: 0px;
      min-width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      font-family: var(--font-family);
      &:first-child {
        border-top-left-radius: var(--border-radius, 20px);
        border-bottom-left-radius: var(--border-radius, 20px);
      }
      &:not(:last-child) {
        border-right: 1px solid var(--color-outline);
      }
      &:last-child {
        border-top-right-radius: var(--border-radius, 20px);
        border-bottom-right-radius: var(--border-radius, 20px);
      }
    }
    .selected-segment {
      color: var(--color-on-primary-container);
      background-color: var(--color-primary-container);
    }
  }
}

.filters-segment-container {
  overflow-y: visible;
  height: 100%;
  max-height: calc(100% - 64px - 42px - 32px);
}

.back-filters-container {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1099;
}

.divider {
  margin: 16px;
  border-top: 1px solid var(--color-outline);
}

.filters-options-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  margin: 0px 16px;
  .filters-options-buttons-container {
    display: flex;
    .filter-option-button {
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      font-weight: 500;
      padding: 8px 16px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: var(--elevation-0);
      border: none;
      -webkit-tap-highlight-color: transparent;
      line-height: 20px;
      color: var(--color-primary-app);
      background-color: transparent;
      font-family: var(--font-family);
    }
  }
}

.segment-container {
  overflow: scroll;
  height: 100%;
}

.filter-container {
  &:not(:last-child) {
    &::after {
      content: '';
      display: block;
      margin: 16px;
      border-top: 1px solid var(--color-outline);
    }
  }
  &:last-child {
    margin-bottom: 16px;
  }
}

.current-treks-within-bounds-length {
  color: var(--color-on-surface-variant);
  font-family: var(--font-family);
}
